/*
 *	Mapping of module names (string) to their corresponding FontAwesome icons (IconDefinition).
 */

// Import necessary FontAwesome icons
import {
	faUsers,
	faAddressCard,
	faFileContract,
	faBox,
	faFileInvoiceDollar,
	faIndustry,
	faLayerGroup,
	faHandshake,
	faBriefcase,
	faChartLine,
	faTrophy,
	faServer,
	faPuzzlePiece,
	faDownload,
	faPercent,
	faBuilding,
	faReceipt,
	faFile,
	faDiagramSuccessor,
} from '@fortawesome/free-solid-svg-icons';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

// Export the icon mapping as a record
export const iconMap: Record<string, IconDefinition> = {
	// RH
	faUsers: faUsers,
	faAddressCard: faAddressCard,

	// GRC
	faBuilding: faBuilding,
	faFileContract: faFileContract,
	faBox: faBox,
	faFileInvoiceDollar: faFileInvoiceDollar,

	// GRF
	faIndustry: faIndustry,
	// faFileContract et faBox sont déjà définis pour GRC, on peut les réutiliser
	// faFileInvoiceDollar déjà défini

	// PM
	faLayerGroup: faLayerGroup,
	faHandshake: faHandshake,
	faPercent: faPercent,

	// GPO
	faBriefcase: faBriefcase,
	faReceipt: faReceipt,
	faChartLine: faChartLine,
	faTrophy: faTrophy,

	// Système
	faDiagramSuccessor: faDiagramSuccessor,
	faServer: faServer,
	faFile: faFile,
	faDownload: faDownload,

	// Default
	default: faPuzzlePiece,
};
